// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.status-dot[data-v-a0edf17a] {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 5px;\n}\n.status-on[data-v-a0edf17a] {\n    background-color: var(--v-success-base);\n}\n.status-off[data-v-a0edf17a] {\n    background-color: #999;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
